import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Fireworks from "./Fireworks";
import MemoryService from "./MemoryService";
import "./PhotoPage.css";

function PhotoPage() {
  const { photoId } = useParams();
  const [memory, setMemory] = useState(null);
  const [showFireworks, setShowFireworks] = useState(true);

  useEffect(() => {
    // Load memories from API
    const loadMemory = async () => {
      try {
        const memories = await MemoryService.loadMemories();
        const foundMemory = memories.find(m => m.id === parseInt(photoId));
        setMemory(foundMemory);
      } catch (error) {
        console.error('Error loading memory:', error);
        // No fallback memories - just show not found
        setMemory(null);
      }
    };

    loadMemory();
  }, [photoId]);

  useEffect(() => {
    // Hide fireworks after 3 seconds
    const timer = setTimeout(() => {
      setShowFireworks(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const getImageSrc = (memory) => {
    if (memory.imageUrl) {
      return memory.imageUrl; // Use S3 URL from API
    }
    if (memory.imageData) {
      return memory.imageData; // Use base64 data
    }
    if (memory.file && memory.file instanceof File) {
      return URL.createObjectURL(memory.file); // Only if it's actually a File object
    }
    return `/photos/${memory.filename}`; // Fallback to existing photos
  };

  if (!memory) {
    return (
      <div className="photo-page">
        <div className="photo-not-found">
          <h2>Memory not found</h2>
          <Link to="/" className="back-link">← Back to Gallery</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="photo-page">
      {showFireworks && <Fireworks duration={3000} />}
      
      <header className="photo-header">
        <Link to="/" className="back-link">← Back to Gallery</Link>
        <h1>Our Journey Together ❤️</h1>
      </header>

      <main className="photo-main">
        <div className="photo-container">
          <img
            src={getImageSrc(memory)}
            alt={memory.title}
            className="featured-photo"
          />
        </div>
        
        <div className="photo-details">
          <h2>{memory.title}</h2>
          <p className="photo-date">{memory.date}</p>
          <p className="photo-description">{memory.description}</p>
        </div>
      </main>
    </div>
  );
}

export default PhotoPage;
